/** Arrival (§15.2 #3, §15.6): the role card, the public Guest List and the table rules. */
import { RuleChanges } from "../components/RulesBadge.tsx";
import { useView } from "../lib/view.ts";
import { AnalyticsNotice } from "./lobby/Analytics.tsx";
import { GuestList, RoleCard, TableRules } from "./RoleCard.tsx";

export function Arrival() {
  const view = useView();
  const rules = view.public.rules;
  return (
    <div className="stack" data-testid="arrival">
      <div className="center">
        <h1>Welcome to the gala</h1>
        <p className="muted">Check your role in private. Mingling starts when the timer ends.</p>
      </div>
      <RoleCard />
      <GuestList list={view.public.guestList} />
      <TableRules />
      {rules && rules.changes.length > 0 ? (
        <section className="panel">
          <h3>{rules.badge}</h3>
          <RuleChanges rules={rules} />
        </section>
      ) : null}
      <AnalyticsNotice />
    </div>
  );
}
